import React from 'react'

const WhatIsDailyReport = ({setShowWhatIsDailyReport}) => {
    return (
        <div className="daily-report-settings-modal-overlay">
            <div className="daily-report-explanation-modal">
                <div className="daily-report-explanation-close close-btn" onClick={() => setShowWhatIsDailyReport(false)}>×</div>
                <div className="about-daily-report">
                    <p className="daily-report-exp-title">デイリーレポートとは</p>
                    <p><i className="fa-solid fa-check check-icon-daily-report-explanation"></i>デイリーレポートとは前日の株価、ニュース、適時開示、決算情報といった企業にとって重要な情報を AI がまとめたレポートです。</p>
                    <p><i className="fa-solid fa-check check-icon-daily-report-explanation"></i>企業を登録するだけで毎朝、必要な情報が自動で収集され、分析されたレポートを受け取ることができます。</p>
                    <div className="daily-report-sample">
                        <img src="img/toyota_20240508.png" alt="daily report sample" className="daily-report-sample-image" />
                    </div>
                    <div className="daily-report-example-link">
                        <a href="daily-report/7203/20240508/" target="_blank"><i className="fa-regular fa-lightbulb daily-report-light"></i>デイリーレポートのサンプルはこちら</a>
                    </div>
                    <p id="daily-report-character"><span className="bold">デイリーレポートの特長</span></p>
                    <ul>
                        <li><div className="bold">時間の節約</div>煩雑な情報収集作業から解放され、投資家、経営者、マーケティング担当者はより戦略的な業務に集中できます。</li>
                        <li><div className="bold">最新情報の常時把握</div>最新かつ関連性の高い情報を見逃さずキャッチ。これにより市場や競合他社の動向をリアルタイムで把握することが可能になります。</li>
                        <li><div className="bold">アクセスの容易さ</div>スマートフォンやタブレット、PCからいつでもどこでもアクセス可能。忙しい朝でも、通勤中に最新の情報を確認できます。</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default WhatIsDailyReport